(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cookie-consent')) {
    customElements.define(
      'cookie-consent',
      class CookieConsent extends HTMLElement {
        connectedCallback() {
          this.intro = this.querySelector('[data-view="intro"]');
          this.prefs = this.querySelector('[data-view="prefs"]');
          this.querySelector('[data-accept-all]')?.addEventListener('click', () =>
            this.save({ analytics: true, marketing: true, preferences: true })
          );
          this.querySelector('[data-decline]')?.addEventListener('click', () =>
            this.save({ analytics: false, marketing: false, preferences: false })
          );
          this.querySelector('[data-manage]')?.addEventListener('click', () => this.toggle(true));
          this.querySelector('[data-back]')?.addEventListener('click', () => this.toggle(false));
          this.prefs?.addEventListener('submit', (event) => {
            event.preventDefault();
            const data = new FormData(this.prefs);
            this.save({
              analytics: data.has('analytics'),
              marketing: data.has('marketing'),
              preferences: data.has('preferences'),
            });
          });

          if (!window.avelaCookiePreferences) {
            window.avelaCookiePreferences = true;
            document.addEventListener('click', (event) => {
              if (!event.target.closest('[data-cookie-preferences]')) return;
              event.preventDefault();
              document.querySelector('cookie-consent')?.openPreferences();
            });
          }

          if (!window.Shopify?.loadFeatures) return;
          window.Shopify.loadFeatures(
            [{ name: 'consent-tracking-api', version: '0.1' }],
            (error) => {
              if (error || !window.Shopify.customerPrivacy) return;
              if (this.shouldDisplay()) this.hidden = false;
            }
          );
        }

        shouldDisplay() {
          const api = window.Shopify.customerPrivacy;
          const consent = api.currentVisitorConsent?.() || {};
          const undecided = !consent.analytics && !consent.marketing && !consent.preferences;
          if (typeof api.shouldShowBanner === 'function') {
            return api.shouldShowBanner() && undecided;
          }
          return undecided;
        }

        openPreferences() {
          const consent = window.Shopify?.customerPrivacy?.currentVisitorConsent?.() || {};
          ['analytics', 'marketing', 'preferences'].forEach((name) => {
            const input = this.prefs?.elements[name];
            if (input && consent[name] !== undefined && consent[name] !== '') input.checked = consent[name] === 'yes';
          });
          this.toggle(true);
          this.hidden = false;
          this.prefs?.querySelector('input')?.focus();
        }

        toggle(manage) {
          this.intro.hidden = manage;
          this.prefs.hidden = !manage;
        }

        save(consent) {
          window.Shopify.customerPrivacy.setTrackingConsent(consent, () => {
            this.hidden = true;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('predictive-search')) {
    customElements.define(
      'predictive-search',
      class PredictiveSearch extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input[type="search"]');
          this.results = this.querySelector('[data-predictive-results]');
          this.controller = null;
          this.input.addEventListener(
            'input',
            this.debounce(() => this.onChange(), 280)
          );
          this.input.addEventListener('focus', () => {
            if (this.input.value.trim()) this.onChange();
          });
          this.addEventListener('keydown', (event) => this.onKeydown(event));
        }

        onChange() {
          const term = this.input.value.trim();
          if (!term.length) {
            this.close();
            return;
          }
          this.getResults(term);
        }

        async getResults(term) {
          this.controller?.abort();
          this.controller = new AbortController();
          const url = new URL(this.dataset.url, window.location.origin);
          url.searchParams.set('q', term);
          url.searchParams.set('section_id', 'predictive-search');
          url.searchParams.set('resources[type]', 'query,product,collection,page,article');
          url.searchParams.set('resources[limit]', '6');
          url.searchParams.set('resources[limit_scope]', 'each');
          url.searchParams.set('resources[options][unavailable_products]', 'hide');
          this.results.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(url, { signal: this.controller.signal });
            if (!response.ok) {
              this.close();
              return;
            }
            const html = await response.text();
            const section = new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('#shopify-section-predictive-search');
            this.results.innerHTML = section ? section.innerHTML : '';
            this.open();
          } catch (error) {
            if (error.name !== 'AbortError') this.close();
          } finally {
            this.results.removeAttribute('aria-busy');
          }
        }

        onKeydown(event) {
          const options = Array.from(this.results.querySelectorAll('[role="option"]'));
          if (event.key === 'Escape') {
            this.close();
            return;
          }
          if (event.key === 'Enter') {
            const selected = options.find((option) => option.getAttribute('aria-selected') === 'true');
            if (selected?.href) {
              event.preventDefault();
              window.location.assign(selected.href);
            }
            return;
          }
          if (!options.length || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return;
          event.preventDefault();
          const current = options.findIndex((option) => option.getAttribute('aria-selected') === 'true');
          let next = event.key === 'ArrowDown' ? current + 1 : current - 1;
          if (next < 0) next = options.length - 1;
          if (next >= options.length) next = 0;
          options.forEach((option, index) => option.setAttribute('aria-selected', String(index === next)));
          options[next]?.scrollIntoView({ block: 'nearest' });
          this.input.setAttribute('aria-activedescendant', options[next]?.id || '');
        }

        syncOverlay() {
          this.closest('.header-search')?.classList.toggle(
            'is-searching',
            Boolean(this.results.innerHTML.trim())
          );
        }

        open() {
          this.input.setAttribute('aria-expanded', 'true');
          this.syncOverlay();
        }

        close() {
          this.results.innerHTML = '';
          this.input.setAttribute('aria-expanded', 'false');
          this.input.removeAttribute('aria-activedescendant');
          this.syncOverlay();
        }

        debounce(fn, wait) {
          let timer;
          return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), wait);
          };
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.__avelaProductCardGalleryV7) {
    window.__avelaProductCardGalleryV7 = true;

    const hydrateImages = (root) => {
      if (!root || root.dataset.imagesReady === 'true') return;
      root.dataset.imagesReady = 'true';
      root.querySelectorAll('img[data-src]').forEach((img) => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    };

    document.addEventListener(
      'pointerover',
      (event) => {
        const card = event.target.closest?.('.product-card');
        if (card) hydrateImages(card);
      },
      true
    );

    document.addEventListener(
      'pointerdown',
      (event) => {
        const card = event.target.closest?.('.product-card');
        if (card) hydrateImages(card);
      },
      true
    );

    const galleryOf = (node) => node?.closest?.('[data-product-gallery]');
    const trackOf = (gallery) => gallery?.querySelector('[data-product-gallery-track]');
    const slidesOf = (gallery) => [...gallery.querySelectorAll('.product-card__slide')];
    const dotsOf = (gallery) => [...gallery.querySelectorAll('[data-product-gallery-dot]')];
    const widthOf = (track) => track.clientWidth || 1;
    const indexOf = (track) => Math.round(track.scrollLeft / widthOf(track));
    const goTo = (gallery, index) => {
      const track = trackOf(gallery);
      const slides = slidesOf(gallery);
      if (!track || slides.length < 2) return;
      const nextIndex = ((index % slides.length) + slides.length) % slides.length;
      track.classList.add('is-dragging');
      track.scrollTo({ left: nextIndex * widthOf(track), behavior: 'auto' });
      dotsOf(gallery).forEach((dot, i) => dot.classList.toggle('is-active', i === nextIndex));
      requestAnimationFrame(() => {
        requestAnimationFrame(() => track.classList.remove('is-dragging'));
      });
    };

    document.addEventListener(
      'click',
      (event) => {
        const next = event.target.closest('[data-product-gallery-next]');
        const prev = event.target.closest('[data-product-gallery-prev]');
        const dot = event.target.closest('[data-product-gallery-dot]');
        const control = next || prev || dot;
        const gallery = galleryOf(control);
        if (!gallery) return;
        hydrateImages(gallery);
        event.preventDefault();
        event.stopPropagation();
        const track = trackOf(gallery);
        if (!track) return;
        if (next) goTo(gallery, indexOf(track) + 1);
        else if (prev) goTo(gallery, indexOf(track) - 1);
        else goTo(gallery, dotsOf(gallery).indexOf(dot));
      },
      true
    );

    let drag = null;
    let suppressClick = false;
    document.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      if (event.target.closest('[data-product-gallery-next], [data-product-gallery-prev], [data-product-gallery-dot]')) {
        return;
      }
      const track = event.target.closest('[data-product-gallery-track]');
      const gallery = galleryOf(track);
      if (!track || !gallery || slidesOf(gallery).length < 2) return;
      drag = {
        track,
        gallery,
        startX: event.clientX,
        startScroll: track.scrollLeft,
        moved: false,
        captured: false,
      };
    });

    document.addEventListener('pointermove', (event) => {
      if (!drag) return;
      const dx = event.clientX - drag.startX;
      if (!drag.moved && Math.abs(dx) <= 6) return;
      if (!drag.moved) {
        drag.moved = true;
        drag.track.classList.add('is-dragging');
        if (!drag.captured) {
          drag.captured = true;
          try {
            drag.track.setPointerCapture(event.pointerId);
          } catch (error) {
            drag.captured = false;
          }
        }
      }
      event.preventDefault();
      drag.track.scrollLeft = drag.startScroll - dx;
    });

    const endDrag = () => {
      if (!drag) return;
      const { track, gallery, startScroll, moved } = drag;
      if (moved) {
        suppressClick = true;
        const dx = track.scrollLeft - startScroll;
        const threshold = widthOf(track) * 0.18;
        let index = indexOf(track);
        if (dx > threshold) index = Math.ceil(startScroll / widthOf(track));
        if (dx < -threshold) index = Math.floor(startScroll / widthOf(track));
        goTo(gallery, index);
      } else {
        track.classList.remove('is-dragging');
      }
      drag = null;
    };

    let wheelLock = false;
    document.addEventListener(
      'wheel',
      (event) => {
        const track = event.target.closest?.('[data-product-gallery-track]');
        const gallery = galleryOf(track);
        if (!track || !gallery || slidesOf(gallery).length < 2) return;
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (!horizontal && !event.shiftKey) return;
        const delta = horizontal ? event.deltaX : event.deltaY;
        if (Math.abs(delta) < 8) return;
        event.preventDefault();
        if (wheelLock) return;
        wheelLock = true;
        goTo(gallery, indexOf(track) + (delta > 0 ? 1 : -1));
        window.setTimeout(() => {
          wheelLock = false;
        }, 280);
      },
      { passive: false, capture: true }
    );

    // Fareyle kartın üzerine gelince ikinci fotoğrafı göster, ayrılınca ilkine dön
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    document.addEventListener('pointerover', (event) => {
      if (event.pointerType !== 'mouse' || !canHover.matches) return;
      const gallery = event.target.closest?.('[data-product-gallery]');
      if (!gallery || gallery.contains(event.relatedTarget)) return;
      const track = trackOf(gallery);
      if (!track || slidesOf(gallery).length < 2 || indexOf(track) !== 0) return;
      hydrateImages(gallery.closest('.product-card'));
      gallery.dataset.hoverSwap = 'true';
      goTo(gallery, 1);
    });

    document.addEventListener('pointerout', (event) => {
      if (event.pointerType !== 'mouse') return;
      const gallery = event.target.closest?.('[data-product-gallery]');
      if (!gallery || gallery.contains(event.relatedTarget) || gallery.dataset.hoverSwap !== 'true') return;
      delete gallery.dataset.hoverSwap;
      const track = trackOf(gallery);
      if (track && indexOf(track) === 1 && !drag) goTo(gallery, 0);
    });

    // Görünen kartların ikinci fotoğrafını sayfa yüklendikten sonra önceden indir,
    // böylece üzerine gelince veya kaydırınca fotoğraf beklemeden açılır
    const warmSecondSlide = (gallery) => {
      const img = gallery.querySelectorAll('.product-card__slide img')[1];
      if (!img || !img.dataset.src) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    };
    const startWarmup = () => {
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            warmSecondSlide(entry.target);
          });
        },
        { rootMargin: '200px 0px' }
      );
      document.querySelectorAll('[data-product-gallery]').forEach((gallery) => observer.observe(gallery));
    };
    const scheduleWarmup = () => {
      if ('requestIdleCallback' in window) window.requestIdleCallback(startWarmup, { timeout: 2000 });
      else window.setTimeout(startWarmup, 500);
    };
    if (document.readyState === 'complete') scheduleWarmup();
    else window.addEventListener('load', scheduleWarmup, { once: true });

    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
    document.addEventListener(
      'click',
      (event) => {
        const slide = event.target.closest('a.product-card__slide');
        if (!slide || !slide.closest('[data-product-gallery-track]')) return;
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
          return;
        }
        const href = slide.getAttribute('href');
        if (!href || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }
        event.preventDefault();
        window.location.assign(href);
      },
      true
    );

    document.addEventListener(
      'scroll',
      (event) => {
        const track = event.target;
        if (!(track instanceof HTMLElement) || !track.hasAttribute('data-product-gallery-track')) return;
        const gallery = galleryOf(track);
        if (!gallery) return;
        const index = indexOf(track);
        dotsOf(gallery).forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gallery')) {
    customElements.define(
      'product-gallery',
      class ProductGallery extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-gallery-viewport]');
          this.dialog = this.querySelector('[data-zoom-dialog]');
          this.lightbox = this.querySelector('[data-lightbox-viewport]');
          this.colorIndex = Number(this.dataset.colorIndex ?? -1);
          this.collectVisible();
          this.dragged = false;
          this.pointerX = 0;

          this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.step(this.viewport, this.slides, -1));
          this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.step(this.viewport, this.slides, 1));
          this.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => this.step(this.lightbox, this.lightboxSlides, -1));
          this.querySelector('[data-lightbox-next]')?.addEventListener('click', () => this.step(this.lightbox, this.lightboxSlides, 1));

          this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', (event) => {
              event.preventDefault();
              this.goTo(this.viewport, this.slides, Number(thumb.dataset.galleryThumb));
            });
          });

          this.querySelectorAll('[data-zoom-src]').forEach((button) => {
            button.addEventListener('pointerdown', (event) => {
              this.dragged = false;
              this.pointerX = event.clientX;
            });
            button.addEventListener('pointermove', (event) => {
              if (Math.abs(event.clientX - this.pointerX) > 10) this.dragged = true;
            });
            button.addEventListener('click', () => {
              if (this.dragged) return;
              this.openLightbox(button.closest('.product-gallery__slide')?.id);
            });
          });

          this.querySelector('[data-zoom-close]')?.addEventListener('click', () => this.closeLightbox());
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.closeLightbox();
          });
          this.dialog?.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.step(this.lightbox, this.lightboxSlides, -1);
            if (event.key === 'ArrowRight') this.step(this.lightbox, this.lightboxSlides, 1);
            if (event.key === 'Escape' && !this.dialog.showModal) this.closeLightbox();
          });

          this.viewport?.addEventListener('scroll', () => this.syncThumbs(), { passive: true });
          this.bindDrag(this.viewport);
          this.bindDrag(this.lightbox);
          this.bindZoom();
          this.dialog?.addEventListener('close', () => this.resetZoom());
          this.syncThumbs();
          this.warmColorImages();
        }

        warmColorImages() {
          // Sayfa yüklendikten sonra diğer renklerin ilk fotoğraflarını önceden indir
          const warm = () => {
            const seen = new Set();
            this.querySelectorAll('.product-gallery__slide[hidden]').forEach((slide) => {
              const group = slide.dataset.mediaGroup;
              if (!group || seen.has(group)) return;
              seen.add(group);
              const image = slide.querySelector('img');
              if (image) image.loading = 'eager';
            });
          };
          const schedule = () => {
            if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 3000 });
            else window.setTimeout(warm, 1000);
          };
          if (document.readyState === 'complete') schedule();
          else window.addEventListener('load', schedule, { once: true });
        }

        collectVisible() {
          this.slides = Array.from(this.querySelectorAll('.product-gallery__slide:not([hidden])'));
          this.thumbs = Array.from(this.querySelectorAll('.product-gallery__thumbs li:not([hidden]) [data-gallery-thumb]'));
          this.thumbs.forEach((thumb, index) => {
            thumb.dataset.galleryThumb = String(index);
          });
          this.lightboxSlides = Array.from(this.querySelectorAll('.product-zoom__slide:not([hidden])'));
        }

        showVariant(variant) {
          if (this.colorIndex < 0 || !variant?.options) return;
          const group = variant.options[this.colorIndex];
          const items = this.querySelectorAll('[data-media-group]');
          const known = Array.from(items).some((item) => item.dataset.mediaGroup === group);
          items.forEach((item) => {
            const itemGroup = item.dataset.mediaGroup;
            item.hidden = known && itemGroup !== '' && itemGroup !== group;
          });
          this.collectVisible();
          this.slides.forEach((slide) => {
            const image = slide.querySelector('img');
            if (image) image.loading = 'eager';
          });
          this.viewport?.scrollTo({ left: 0, behavior: 'auto' });
          this.syncThumbs(0);
        }

        bindDrag(viewport) {
          if (!viewport) return;
          let dragging = false;
          let startX = 0;
          let lastX = 0;
          let startScroll = 0;
          let startIndex = 0;
          let pointerId = null;

          viewport.addEventListener('pointerdown', (event) => {
            if (event.pointerType === 'touch' || event.button !== 0) return;
            if (viewport === this.lightbox && this.zoomedSlide) return;
            dragging = true;
            this.dragged = false;
            pointerId = event.pointerId;
            startX = event.clientX;
            lastX = event.clientX;
            startScroll = viewport.scrollLeft;
          });
          viewport.addEventListener('pointermove', (event) => {
            if (!dragging) return;
            const dx = event.clientX - startX;
            lastX = event.clientX;
            if (!this.dragged && Math.abs(dx) <= 8) return;
            if (!this.dragged) {
              this.dragged = true;
              startIndex = this.indexOf(viewport, viewport === this.lightbox ? this.lightboxSlides : this.slides);
              viewport.style.scrollSnapType = 'none';
              viewport.style.scrollBehavior = 'auto';
              viewport.setPointerCapture?.(pointerId);
            }
            viewport.scrollLeft = startScroll - dx;
          });
          const endDrag = () => {
            if (!dragging) return;
            dragging = false;
            if (!this.dragged) return;
            const slides = viewport === this.lightbox ? this.lightboxSlides : this.slides;
            const dx = lastX - startX;
            const threshold = Math.min(60, viewport.clientWidth * 0.15);
            const direction = dx < -threshold ? 1 : dx > threshold ? -1 : 0;
            viewport.style.scrollSnapType = '';
            viewport.style.scrollBehavior = '';
            this.goTo(viewport, slides, startIndex + direction);
          };
          viewport.addEventListener('pointerup', endDrag);
          viewport.addEventListener('pointercancel', endDrag);
        }

        indexOf(viewport, slides) {
          if (!viewport || !slides.length) return 0;
          return Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
        }

        goTo(viewport, slides, index) {
          if (!viewport || !slides.length) return;
          if (viewport === this.lightbox) this.resetZoom();
          const next = ((index % slides.length) + slides.length) % slides.length;
          viewport.scrollTo({ left: next * viewport.clientWidth, behavior: 'smooth' });
          if (viewport === this.viewport) this.syncThumbs(next);
        }

        step(viewport, slides, direction) {
          this.goTo(viewport, slides, this.indexOf(viewport, slides) + direction);
        }

        syncThumbs(index) {
          const current = index ?? this.indexOf(this.viewport, this.slides);
          this.thumbs.forEach((thumb, thumbIndex) => {
            thumb.classList.toggle('is-active', thumbIndex === current);
          });
        }

        openLightbox(mediaId) {
          if (!this.dialog || !this.lightbox) return;
          const imageIndex = this.lightboxSlides.findIndex((slide) => slide.dataset.mediaId === mediaId);
          const target = imageIndex < 0 ? 0 : imageIndex;
          this.lightboxSlides.forEach((slide) => {
            const image = slide.querySelector('img');
            if (image) image.loading = 'eager';
          });
          if (typeof this.dialog.showModal === 'function') {
            this.dialog.showModal();
          } else {
            this.dialog.setAttribute('open', '');
            this.dialog.classList.add('product-zoom--fallback');
            document.documentElement.style.overflow = 'hidden';
            this.querySelector('[data-zoom-close]')?.focus();
          }
          const align = () => this.lightbox.scrollTo({ left: target * this.lightbox.clientWidth, behavior: 'auto' });
          requestAnimationFrame(() => requestAnimationFrame(align));
        }

        bindZoom() {
          const scale = 2.5;
          let pan = null;

          this.lightboxSlides.forEach((slide) => {
            const image = slide.querySelector('img');
            if (!image) return;

            slide.addEventListener('click', (event) => {
              if (this.dragged || this.zoomPanned) {
                this.zoomPanned = false;
                return;
              }
              if (this.zoomedSlide === slide) {
                this.resetZoom();
                return;
              }
              this.resetZoom();
              const rect = image.getBoundingClientRect();
              const x = ((event.clientX - rect.left) / rect.width) * 100;
              const y = ((event.clientY - rect.top) / rect.height) * 100;
              image.sizes = '200vw';
              image.style.transformOrigin = `${Math.min(100, Math.max(0, x))}% ${Math.min(100, Math.max(0, y))}%`;
              image.style.transform = `scale(${scale})`;
              slide.classList.add('is-zoomed');
              this.dialog?.classList.add('is-zoomed');
              this.zoomedSlide = slide;
            });

            slide.addEventListener('pointerdown', (event) => {
              if (this.zoomedSlide !== slide) return;
              this.zoomPanned = false;
              const origin = image.style.transformOrigin.split(' ').map((value) => Number.parseFloat(value) || 50);
              pan = { id: event.pointerId, x: event.clientX, y: event.clientY, ox: origin[0], oy: origin[1] };
            });

            slide.addEventListener('pointermove', (event) => {
              if (this.zoomedSlide !== slide) return;
              const rect = slide.getBoundingClientRect();
              if (event.pointerType === 'mouse' && !pan) {
                const x = ((event.clientX - rect.left) / rect.width) * 100;
                const y = ((event.clientY - rect.top) / rect.height) * 100;
                image.style.transformOrigin = `${Math.min(100, Math.max(0, x))}% ${Math.min(100, Math.max(0, y))}%`;
                return;
              }
              if (!pan || pan.id !== event.pointerId) return;
              const dx = event.clientX - pan.x;
              const dy = event.clientY - pan.y;
              if (Math.abs(dx) > 8 || Math.abs(dy) > 8) this.zoomPanned = true;
              if (!this.zoomPanned) return;
              const ox = pan.ox - (dx / rect.width) * (100 / (scale - 1));
              const oy = pan.oy - (dy / rect.height) * (100 / (scale - 1));
              image.style.transformOrigin = `${Math.min(100, Math.max(0, ox))}% ${Math.min(100, Math.max(0, oy))}%`;
            });

            const endPan = () => {
              pan = null;
            };
            slide.addEventListener('pointerup', endPan);
            slide.addEventListener('pointercancel', endPan);
          });
        }

        resetZoom() {
          const slide = this.zoomedSlide;
          this.zoomedSlide = null;
          this.zoomPanned = false;
          this.dialog?.classList.remove('is-zoomed');
          if (!slide) return;
          slide.classList.remove('is-zoomed');
          const image = slide.querySelector('img');
          if (image) {
            image.style.transform = '';
            image.style.transformOrigin = '';
          }
        }

        closeLightbox() {
          if (!this.dialog) return;
          if (typeof this.dialog.close === 'function' && this.dialog.showModal) {
            this.dialog.close();
            return;
          }
          this.dialog.removeAttribute('open');
          this.dialog.classList.remove('product-zoom--fallback');
          document.documentElement.style.overflow = '';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recently-viewed"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('recently-viewed')) {
    customElements.define(
      'recently-viewed',
      class RecentlyViewed extends HTMLElement {
        connectedCallback() {
          const storageKey = 'avela-recent';
          const current = {
            id: this.dataset.id,
            url: this.dataset.url,
            title: this.dataset.title,
            image: this.dataset.image,
            price: this.dataset.price,
          };
          let items = [];
          try {
            items = JSON.parse(localStorage.getItem(storageKey) || '[]');
          } catch (error) {
            items = [];
          }
          items = items.filter((item) => item.id !== current.id);
          const others = items.slice(0, 4);
          items.unshift(current);
          localStorage.setItem(storageKey, JSON.stringify(items.slice(0, 8)));
          if (!others.length) return;
          const list = this.querySelector('[data-recent-list]');
          others.forEach((item) => {
            const li = document.createElement('li');
            const link = document.createElement('a');
            link.className = 'recently-viewed__card';
            link.href = item.url || '#';
            if (item.image) {
              const image = document.createElement('img');
              image.src = item.image;
              image.alt = item.title || '';
              image.width = 400;
              image.height = 533;
              image.loading = 'lazy';
              link.appendChild(image);
            }
            const title = document.createElement('span');
            title.textContent = item.title || '';
            const price = document.createElement('span');
            price.className = 'text-caption';
            price.textContent = item.price || '';
            link.append(title, price);
            li.appendChild(link);
            list.appendChild(li);
          });
          this.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
